module.exports = "./dist/assets/images/icons/42f9a730f830475703132bbbec680856.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icons/maestro.png
// module id = ./assets/images/icons/maestro.png
// module chunks = 0